var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10591_3895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4098 30.4346L23.2702 4.21203C22.4832 2.84901 21.0737 2.03534 19.5 2.03534C17.9262 2.03534 16.5167 2.84909 15.7297 4.21203L0.590169 30.4346C-0.196764 31.7976 -0.196764 33.425 0.590169 34.788C1.3771 36.151 2.78651 36.9647 4.36038 36.9647H34.6396C36.2134 36.9647 37.6229 36.151 38.4098 34.788C39.1967 33.425 39.1967 31.7976 38.4098 30.4346ZM36.4293 33.6445C36.0557 34.2915 35.3867 34.6778 34.6396 34.6778H4.36038C3.61328 34.6778 2.94419 34.2915 2.57064 33.6445C2.19709 32.9975 2.19709 32.2249 2.57064 31.5779L17.7102 5.35537C18.0838 4.70837 18.7529 4.3221 19.5 4.3221C20.247 4.3221 20.9161 4.70837 21.2897 5.35537L36.4293 31.5779C36.8029 32.2249 36.8029 32.9975 36.4293 33.6445Z",
    fill: "#326164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 27.055C18.6593 27.055 17.9754 27.7389 17.9754 28.5796C17.9754 29.4202 18.6593 30.1042 19.5 30.1042C20.3406 30.1042 21.0245 29.4202 21.0245 28.5796C21.0245 27.7389 20.3406 27.055 19.5 27.055Z",
    fill: "#326164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6433 12.9526H18.3565V24.768H20.6433V12.9526Z",
    fill: "#326164"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10591_3895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.f4284fbd2d06946871479b9bc613a425.svg";
export { ForwardRef as ReactComponent };